export let OEmbedInfo;
(function (_OEmbedInfo) {
  let Type = /*#__PURE__*/function (Type) {
    Type["LINK"] = "link";
    Type["PHOTO"] = "photo";
    Type["RICH"] = "rich";
    Type["VIDEO"] = "video";
    return Type;
  }({});
  _OEmbedInfo.Type = Type;
})(OEmbedInfo || (OEmbedInfo = {}));